export const EmailServiceParams = {
  PAGE_URL: 'PAGE_URL',
  TITLE: 'TITLE',
  DESCRIPTION: 'DESCRIPTION',
  IMAGE: 'IMAGE',
  CONTENT_TYPE: 'CONTENT_TYPE',
  FROM_FIRST_NAME: 'FROM_FIRST_NAME',
} as const;

export const EmailServiceEndpoints = {
  SEND_EMAIL: '/api/email/send',
} as const;

export type EmailServiceParam = keyof typeof EmailServiceParams;
export type EmailServiceEndpoint = keyof typeof EmailServiceEndpoints;
